import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  RSelect,
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

const renderWeightText = (value) => (
  <NumericFormat displayType="text" value={value || 0} thousandSeparator="," decimalScale={2} suffix=" kg" />
);

const renderWeight = (value) => (
  <div className="text-right">{renderWeightText(value)}</div>
);

// Kho gia công: tồn hàng của KH có tick "nhận gia công", theo KH + nguyên liệu
const ProcessingInventory = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerId, setCustomerId] = useState();
  const [rangeDate, setRangeDate] = useState({
    startDate: moment().startOf("months").toDate(),
    endDate: moment().endOf("days").toDate(),
  });

  useEffect(() => {
    GET("customer", { isProcessingCustomer: true }, true).then(({ data: res }) => {
      setCustomerOptions((res || []).map((c) => ({ label: c.name, value: c.id })));
    });
  }, []);

  useEffect(() => {
    if (!rangeDate.startDate || !rangeDate.endDate) {
      return;
    }
    setLoading(true);
    GET("processing/inventory", {
      fromDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      toDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
      ...(customerId ? { customerId } : {}),
    }, true)
      .then(({ data: res }) => {
        setData(res?.rows || []);
        setSummary(res?.summary || {});
      })
      .finally(() => setLoading(false));
  }, [rangeDate, customerId]);

  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate).startOf("days").toDate() : startDate,
      endDate: endDate ? moment(endDate).endOf("days").toDate() : endDate,
    });
  };

  const columns = [
    {
      Header: "Khách hàng",
      accessor: (item) => item.customerName,
    },
    {
      Header: "Nguyên liệu",
      accessor: (item) => item.ingredientName,
    },
    {
      Header: "Đầu kỳ",
      accessor: (item) => renderWeight(item.firstWeight),
    },
    {
      // = KL dầu thô ép nhận gia công x tỷ lệ nấu từ dầu ép
      Header: "Nhập sản xuất",
      accessor: (item) => renderWeight(item.produceInWeight),
    },
    {
      Header: "Xuất",
      accessor: (item) => renderWeight(item.outWeight),
    },
    {
      Header: "Cuối kỳ",
      accessor: (item) => renderWeight(item.lastWeight),
    },
  ];

  return (
    <React.Fragment>
      <Head title="Kho gia công" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Kho gia công</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                <li>
                  <div className="form-control-wrap" style={{ width: 250 }}>
                    <RSelect
                      isClearable
                      placeholder="Khách hàng"
                      options={customerOptions}
                      value={customerOptions.find((c) => c.value === customerId) || null}
                      onChange={(val) => setCustomerId(val?.value)}
                    />
                  </div>
                </li>
                <li>
                  <div className="form-control-wrap">
                    <DatePicker
                      selected={rangeDate.startDate}
                      startDate={rangeDate.startDate}
                      onChange={onRangeChange}
                      endDate={rangeDate.endDate}
                      maxDate={new Date()}
                      selectsRange
                      className="form-control date-picker"
                    />
                  </div>
                </li>
              </ul>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div className="table-full-width">
                <Table loading={loading} columns={columns} data={data} notShowPagi />
              </div>
              <div className="d-flex justify-content-end flex-wrap mt-3">
                <span className="mr-4">Đầu kỳ: <b>{renderWeightText(summary.firstWeight)}</b></span>
                <span className="mr-4">Nhập sản xuất: <b>{renderWeightText(summary.produceInWeight)}</b></span>
                <span className="mr-4">Xuất: <b>{renderWeightText(summary.outWeight)}</b></span>
                <span>Cuối kỳ: <b>{renderWeightText(summary.lastWeight)}</b></span>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default ProcessingInventory;
